import { Effect } from "../Materials/effect";
import "./ShadersInclude/clipPlaneFragmentDeclaration";
import "./ShadersInclude/clipPlaneFragment";
var name = 'colorPixelShader';
var shader = "#ifdef VERTEXCOLOR\nvarying vec4 vColor;\n#else\nuniform vec4 color;\n#endif\n#include<clipPlaneFragmentDeclaration>\nvoid main(void) {\n#include<clipPlaneFragment>\n#ifdef VERTEXCOLOR\ngl_FragColor=vColor;\n#else\ngl_FragColor=color;\n#endif\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var colorPixelShader = { name: name, shader: shader };
//# sourceMappingURL=color.fragment.js.map